<ng-container
  *ngIf="
    category === 'subscription' || category === 'oneTimeCharge';
    else variantTwo
  "
>
  <ng-container *ngFor="let section of sections; let indexOfSection = index">
    <hr
      *ngIf="
        isFirstOutOfPackSectionAfterInPackSection(sections, indexOfSection)
      "
    />
    <my-bill-odb-category-section-or-item-variant-one
      [section]="section"
      [categoryDetailValidFor]="categoryDetailValidFor"
    >
    </my-bill-odb-category-section-or-item-variant-one>
  </ng-container>
</ng-container>

<ng-template #variantTwo>
  <div class="rs-entrypoint-container">
    <ng-container *ngFor="let section of sections; let indexOfSection = index">
      <my-bill-odb-section-variant-two
        [label]="section.description ?? identifier"
        [amount]="section.amount"
        [linkZone]="'mybill.detail.' + category"
        (sectionClick)="onUsageSectionClick(section, indexOfSection)"
      ></my-bill-odb-section-variant-two>
    </ng-container>
  </div>
</ng-template>
